var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailAlertActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#2196F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15H5v1h14v-1zM19 17H5v1h14v-1zM16 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM12 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM8 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H6a1.003 1.003 0 0 1-1-1V7a1.003 1.003 0 0 1 1-1h12a1.003 1.003 0 0 1 1 1v6a1.001 1.001 0 0 1-1 1zm0-7H6v6h12V7z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailAlertActiveIcon);
export default __webpack_public_path__ + "static/media/mailAlertActiveIcon.bbe11995b871d371246f1e8831bd3d3a.svg";
export { ForwardRef as ReactComponent };